import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/trust/trust.component').then(m => m.TrustComponent),
  },
];
